/**
 * @generated SignedSource<<5b5ed18cb390766e4af8ca80e6d752ab>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuCaratWeightRange_itemSearch$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useAppliedFilterUrlLabel_itemSearch">;
  readonly " $fragmentType": "SbSharedRefineMenuCaratWeightRange_itemSearch";
};
export type SbSharedRefineMenuCaratWeightRange_itemSearch$key = {
  readonly " $data"?: SbSharedRefineMenuCaratWeightRange_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRefineMenuCaratWeightRange_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRefineMenuCaratWeightRange_itemSearch",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useAppliedFilterUrlLabel_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "e2aa0c773a9d8df9d567d50cac670a7b";

export default node;
